import { render } from "./InputWithoutIcon.vue?vue&type=template&id=164a9397"
import script from "./InputWithoutIcon.vue?vue&type=script&lang=js"
export * from "./InputWithoutIcon.vue?vue&type=script&lang=js"
script.render = render

export default script